import * as React from "react";
import { AutoCompleteInput, Checkbox, Input } from "uxp/components";
import { findAvailableFields, IUIPropertyDefinition } from "../../../common/common";
import { CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "../../../common/ui-props/common";
import { bindContainerId } from "../../../../util";
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput";
import jp from 'jsonpath'
import IconEditor from "../../../common/icon-selector/IconEditor";

export interface IPopulationPercentageWidgetProps {
    firstValueField: string;
    secondValueField: string;
    secondValueConstant: string;
    icon: string;
    iconColor: string;
    label: string;
    labelColor: string;
    refreshInterval: 60000;
    channel: '';
    secondValueIsTotal: boolean;
}


export function PopulationPercentageWidgetProperty(mode: string, props: IPopulationPercentageWidgetProps): IUIPropertyDefinition<IPopulationPercentageWidgetProps> {
    let title = 'Data';
    if (mode == 'icon') {
        title = 'Icon';
    }
    return {
        defaults: props,
        render: (props, uxpContext, contextData, containerId) => {

            let _props = props.uiProps

            let possibleValues = {};
            findAvailableFields(props.parentUIProps.source, props.parentUIProps.datasources, possibleValues);
            let pv = Object.keys(possibleValues);
            pv.sort();

            return <>
                {(mode == 'all' || mode == 'icon') && <PropertyContainer>
                    <PropertyContainerTitle>{''}</PropertyContainerTitle>
                    <PropertyGroup>

                        <PropertyGroupTitle>Data</PropertyGroupTitle>
                        <Property>
                            <PropertyTitle>Refresh Interval (ms)</PropertyTitle>
                            <Input
                                type="number"
                                value={_props?.refreshInterval?.toString() || '0'}
                                onChange={s => {
                                    let num = Number(s) || 0
                                    jp.apply(_props, '$.refreshInterval', () => (num))
                                    props.onChange(Object.assign({}, _props));
                                }}
                            />

                        </Property>

                        <Property>
                            <PropertyTitle>Channel Name</PropertyTitle>
                            <Input
                                value={_props?.channel || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.channel', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                            />

                        </Property>
                        <Property id={bindContainerId('first-value', containerId)}>
                            <PropertyTitle>First Value Field</PropertyTitle>
                            <AutoCompleteInput
                                value={_props.firstValueField || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.firstValueField', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                className="widget-designer-input"
                                options={pv}
                            />

                        </Property>
                        <Property id={bindContainerId('second-value', containerId)}>
                            <PropertyTitle>Second Value Field</PropertyTitle>
                            <AutoCompleteInput
                                value={_props.secondValueField || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.secondValueField', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                className="widget-designer-input"
                                options={pv}
                            />

                        </Property>
                        <Property>
                            <Checkbox
                                checked={_props?.secondValueIsTotal}
                                onChange={s => {
                                    jp.apply(_props, '$.secondValueIsTotal', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                label="Second value represents total"
                            />

                        </Property>
                        <Property>
                            <PropertyTitle>Second Value (Hard-Coded Value)</PropertyTitle>
                            <Input
                                value={_props.secondValueConstant || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.secondValueConstant', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                className="widget-designer-input"

                            />

                        </Property>
                    </PropertyGroup>
                </PropertyContainer>}
                {(mode == 'all' || mode == 'icon') && <PropertyContainer>
                    <PropertyGroup>
                        <PropertyGroupTitle>Icon</PropertyGroupTitle>
                        <Property>
                            <PropertyTitle>{'Icon'}</PropertyTitle>
                            <IconEditor
                                value={_props.icon || ''}
                                onChange={s => {
                                    jp.apply(_props, '$.icon', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                            />
                        </Property>
                        <Property>
                            <PropertyTitle>{'Icon Color'}</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData} color={_props.iconColor || '#424242'}
                                onChange={s => {
                                    jp.apply(_props, '$.iconColor', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                            />
                        </Property>

                    </PropertyGroup>
                </PropertyContainer>}
                {(mode == 'label' || mode == 'all') && <PropertyContainer>
                    <PropertyGroup>
                        <PropertyGroupTitle>Label</PropertyGroupTitle>


                        <Property>
                            <PropertyTitle>Label</PropertyTitle>
                            <WidgetDesignerPillInput
                                value={_props.label || 'Items'}
                                onChange={s => {
                                    jp.apply(_props, '$.label', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}
                                contextData={contextData}
                            />

                        </Property>

                        <Property>
                            <PropertyTitle>Label Color</PropertyTitle>
                            <CustomColorPicker contextData={props.contextData}
                                color={_props.labelColor || '#424242'}
                                onChange={s => {
                                    jp.apply(_props, '$.labelColor', () => (s))
                                    props.onChange(Object.assign({}, _props));
                                }}

                            />

                        </Property>
                    </PropertyGroup>
                </PropertyContainer>
                }
            </>
                ;
        }
    };
}
